//exportCSVFile
//https://medium.com/@danny.pule/export-json-to-csv-file-using-javascript-a0b7bc5b00d2

import {uploadFileForGP} from "@/service/restAPIHelper";
import XLSX from 'xlsx';
import orderBy from 'lodash.orderby';
import moment from 'moment';
export function exportCSVFile(headers, items, fileTitle, sortBy, sortDesc) {
    
    function convertToCSV(objArray) {
        var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
        var str = '';

        //add UTF-8 BOM for excel to read unicode character properly
        //https://stackoverflow.com/questions/17879198/adding-utf-8-bom-to-string-blob
        //https://stackoverflow.com/a/19516038/9171808
        str += "\ufeff" 

        for (var i = 0; i < array.length; i++) {
            var line = '';
            for (var index in array[i]) {
                if (line != ''){
                    if (index.toUpperCase().includes('UPD_DATE') || index.toUpperCase().includes('UPD_BY')){
                        //not export UPD_DATE and UPD_BY
                    } else {
                      line += ','
                    }
                }


                //not export _GEOMETRY, UPD_DATE and UPD_BY
                if (index.toUpperCase().includes('_GEOMETRY') || index.toUpperCase().includes('UPD_DATE') || index.toUpperCase().includes('UPD_BY')) {
                  //ignore geometry
                  //line += JSON.stringify(array[i][index])

                
                //parse timestamp to excel date format if field name contains DATE
                } else if (index.toUpperCase().includes('DATE')
                    && !(array[i][index].toUpperCase() == '"NULL"') 
                    //exscape the first column
                    && i>0) {
                    var timestamp = array[i][index];
                    //replace exscape "", e.g. "1528881480000" and convert to Integer
                    if (array[i][index][0] == '"' && array[i][index][array[i][index].length-1] == '"') {
                        timestamp = parseInt(array[i][index].replace(/"/g, ""));
                    }
                    let dateString = moment(timestamp).format('YYYY-MM-DD');
                    if(dateString == 'Invalid date'){
                        line += '"' + array[i][index] + '"'
                    }else{
                        line += '"' + dateString + '"'
                    }
                    
                }else {
                    // console.log('array[i][index].toUpperCase() == "NULL"', array[i][index].toUpperCase() == '"NULL"');
                    if (array[i][index].toUpperCase() == '"NULL"'){
                        array[i][index] = '""';
                    }
                    // console.log("array[i][index]", array[i][index]);
                    
                    line += array[i][index];
                }
                
            }
    
            str += line + '\r\n';
        }
        
        return str;
    }

    items = formatItemsHandleEscape(items);

    //clone the array first
    // items = items.slice(0);

    //sort the arary if sortBy is provided
    if(sortBy){
        //proper sorting for null values
        //[( o ) => { return o[sortBy] || ''}]
        //https://stackoverflow.com/a/41139912/9171808
        items = orderBy(items, [( o ) => { return o[sortBy] || ''}] ,[sortDesc?'desc':'asc'])
    }
    


    if (headers) {
        items.unshift(headers);
    }

    // Convert Object to JSON
    var jsonObject = JSON.stringify(items);

    var csv = convertToCSV(jsonObject);

    var exportedFilenmae = fileTitle + '.csv' || 'export.csv';
    
    //https://stackoverflow.com/questions/39375076/how-to-display-pdf-blob-on-ios-sent-from-my-angularjs-app
    var blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    if (navigator.msSaveBlob) { // IE 10+
        navigator.msSaveBlob(blob, exportedFilenmae);
    } else {
        var link = document.createElement("a");
        if (link.download !== undefined) { // feature detection
            // Browsers that support HTML5 download attribute
            var url = window.URL.createObjectURL(blob);
         
            link.setAttribute("href", url);
            link.setAttribute("download", exportedFilenmae);
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

        }else{
            //for ios safari, send html instead
            // var wb = XLSX.utils.book_new();
            // var ws = XLSX.utils.json_to_sheet(items);
            // var new_ws_name = "Export";
            // XLSX.utils.book_append_sheet(wb, ws, new_ws_name);
            // var wopts = { bookType:'html', bookSST:false, type:'array' };
            // var wbout = XLSX.write(wb,wopts);
            // var excelBlob = new Blob([wbout], { type: 'text/html' });
            // var url  = window.webkitURL.createObjectURL(excelBlob); 
            // window.location.href = url;
            //var url  = window.webkitURL.createObjectURL(blob); 
            //window.location.href = url;  

            var uploadFileUrl = process.env.__API_URL__ + "/downloadfile"

            uploadFileForGP(uploadFileUrl,blob, exportedFilenmae).then((uploadFileResult)=>{

                window.location.href = process.env.__API_OUTPUT_URL__ + "/"+uploadFileResult;

            });

        }
    }
}

export function exportCSVFile2(headers, items, fileTitle, sortBy, sortDesc) { // for replacement to display time in csv
    
    function convertToCSV(objArray) {
        var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
        var str = '';

        //add UTF-8 BOM for excel to read unicode character properly
        //https://stackoverflow.com/questions/17879198/adding-utf-8-bom-to-string-blob
        //https://stackoverflow.com/a/19516038/9171808
        str += "\ufeff" 

        for (var i = 0; i < array.length; i++) {
            var line = '';
            for (var index in array[i]) {
                if (line != ''){
                    if (index.toUpperCase().includes('UPD_DATE') || index.toUpperCase().includes('UPD_BY')){
                        //not export UPD_DATE and UPD_BY
                    } else {
                      line += ','
                    }
                }


                //not export _GEOMETRY, UPD_DATE and UPD_BY
                if (index.toUpperCase().includes('_GEOMETRY') || index.toUpperCase().includes('UPD_DATE') || index.toUpperCase().includes('UPD_BY')) {
                  //ignore geometry
                  //line += JSON.stringify(array[i][index])

                
                //parse timestamp to excel date format if field name contains DATE
                } else if (index.toUpperCase().includes('DATE')
                    && !(array[i][index].toUpperCase() == '"NULL"') 
                    //exscape the first column
                    && i>0) {
                    var timestamp = array[i][index];
                    //replace exscape "", e.g. "1528881480000" and convert to Integer
                    if (array[i][index][0] == '"' && array[i][index][array[i][index].length-1] == '"') {
                        timestamp = parseInt(array[i][index].replace(/"/g, ""));
                    }
                    let dateString = moment(timestamp).format('YYYY-MM-DD HH:mm');
                    if(dateString == 'Invalid date'){
                        line += '"' + array[i][index] + '"'
                    }else{
                        line += '"' + dateString + '"'
                    }
                    
                }else {
                    // console.log('array[i][index].toUpperCase() == "NULL"', array[i][index].toUpperCase() == '"NULL"');
                    if (array[i][index].toUpperCase() == '"NULL"'){
                        array[i][index] = '""';
                    }
                    // console.log("array[i][index]", array[i][index]);
                    
                    line += array[i][index];
                }
                
            }
    
            str += line + '\r\n';
        }
        
        return str;
    }

    items = formatItemsHandleEscape(items);

    //clone the array first
    // items = items.slice(0);

    //sort the arary if sortBy is provided
    if(sortBy){
        //proper sorting for null values
        //[( o ) => { return o[sortBy] || ''}]
        //https://stackoverflow.com/a/41139912/9171808
        items = orderBy(items, [( o ) => { return o[sortBy] || ''}] ,[sortDesc?'desc':'asc'])
    }
    


    if (headers) {
        items.unshift(headers);
    }

    // Convert Object to JSON
    var jsonObject = JSON.stringify(items);

    var csv = convertToCSV(jsonObject);

    var exportedFilenmae = fileTitle + '.csv' || 'export.csv';
    
    //https://stackoverflow.com/questions/39375076/how-to-display-pdf-blob-on-ios-sent-from-my-angularjs-app
    var blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    if (navigator.msSaveBlob) { // IE 10+
        navigator.msSaveBlob(blob, exportedFilenmae);
    } else {
        var link = document.createElement("a");
        if (link.download !== undefined) { // feature detection
            // Browsers that support HTML5 download attribute
            var url = window.URL.createObjectURL(blob);
         
            link.setAttribute("href", url);
            link.setAttribute("download", exportedFilenmae);
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

        }else{
            //for ios safari, send html instead
            // var wb = XLSX.utils.book_new();
            // var ws = XLSX.utils.json_to_sheet(items);
            // var new_ws_name = "Export";
            // XLSX.utils.book_append_sheet(wb, ws, new_ws_name);
            // var wopts = { bookType:'html', bookSST:false, type:'array' };
            // var wbout = XLSX.write(wb,wopts);
            // var excelBlob = new Blob([wbout], { type: 'text/html' });
            // var url  = window.webkitURL.createObjectURL(excelBlob); 
            // window.location.href = url;
            //var url  = window.webkitURL.createObjectURL(blob); 
            //window.location.href = url;  

            var uploadFileUrl = process.env.__API_URL__ + "/downloadfile"

            uploadFileForGP(uploadFileUrl,blob, exportedFilenmae).then((uploadFileResult)=>{

                window.location.href = process.env.__API_OUTPUT_URL__ + "/"+uploadFileResult;

            });

        }
    }
}

export function exportCSVFileBaseOnHeaders(headers, items, fileTitle, sortBy, sortDesc) {
    
    function convertToCSV(objArray) {
        var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
        var str = '';
        console.log(array);
        //add UTF-8 BOM for excel to read unicode character properly
        //https://stackoverflow.com/questions/17879198/adding-utf-8-bom-to-string-blob
        //https://stackoverflow.com/a/19516038/9171808
        str += "\ufeff" 

        for (var i = 0; i < array.length; i++) {
            var line = '';
            for (var index in array[i]) {
                if (line != ''){
                    //index.toUpperCase() in headers
                    // console.log(index.toUpperCase());
                    if (!(index.toUpperCase() in headers)){
                        //not export UPD_DATE and UPD_BY\                        
                    } else {
                      line += ','
                    }
                }


                //not export _GEOMETRY, UPD_DATE and UPD_BY
                if (!(index.toUpperCase() in headers)) {
                  //ignore geometry
                  //line += JSON.stringify(array[i][index])

                
                //parse timestamp to excel date format if field name contains DATE
                } else if (index.toUpperCase().includes('DATE')
                    && !(array[i][index].toUpperCase() == '"NULL"') 
                    //exscape the first column
                    && i>0&&!(index.toUpperCase() in headers)) {
                    var timestamp = array[i][index];
                    //replace exscape "", e.g. "1528881480000" and convert to Integer
                    if (array[i][index][0] == '"' && array[i][index][array[i][index].length-1] == '"') {
                        timestamp = parseInt(array[i][index].replace(/"/g, ""));
                    }
                    let dateString = moment(timestamp).format('YYYY-MM-DD');
                    if(dateString == 'Invalid date'){
                        line += '"' + array[i][index] + '"'
                    }else{
                        line += '"' + dateString + '"'
                    }
                    
                }else {
                    // console.log('array[i][index].toUpperCase() == "NULL"', array[i][index].toUpperCase() == '"NULL"');
                    if (array[i][index].toUpperCase() == '"NULL"'){
                        array[i][index] = '""';
                    }else{
                        
                    }
                    // console.log("array[i][index]", array[i][index]);
                    
                    line += array[i][index];
                    console.log("the JSON line",line);
                }
                
            }
    
            str += line + '\r\n';
        }
        
        return str;
    }

    items = formatItemsHandleEscape(items);

    //clone the array first
    // items = items.slice(0);

    //sort the arary if sortBy is provided
    if(sortBy){
        //proper sorting for null values
        //[( o ) => { return o[sortBy] || ''}]
        //https://stackoverflow.com/a/41139912/9171808
        items = orderBy(items, [( o ) => { return o[sortBy] || ''}] ,[sortDesc?'desc':'asc'])
    }
    


    if (headers) {
        items.unshift(headers);
    }

    // Convert Object to JSON
    var jsonObject = JSON.stringify(items);

    var csv = convertToCSV(jsonObject);

    var exportedFilenmae = fileTitle + '.csv' || 'export.csv';
    
    //https://stackoverflow.com/questions/39375076/how-to-display-pdf-blob-on-ios-sent-from-my-angularjs-app
    var blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    if (navigator.msSaveBlob) { // IE 10+
        navigator.msSaveBlob(blob, exportedFilenmae);
    } else {
        var link = document.createElement("a");
        if (link.download !== undefined) { // feature detection
            // Browsers that support HTML5 download attribute
            var url = window.URL.createObjectURL(blob);
         
            link.setAttribute("href", url);
            link.setAttribute("download", exportedFilenmae);
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

        }else{
            //for ios safari, send html instead
            // var wb = XLSX.utils.book_new();
            // var ws = XLSX.utils.json_to_sheet(items);
            // var new_ws_name = "Export";
            // XLSX.utils.book_append_sheet(wb, ws, new_ws_name);
            // var wopts = { bookType:'html', bookSST:false, type:'array' };
            // var wbout = XLSX.write(wb,wopts);
            // var excelBlob = new Blob([wbout], { type: 'text/html' });
            // var url  = window.webkitURL.createObjectURL(excelBlob); 
            // window.location.href = url;
            //var url  = window.webkitURL.createObjectURL(blob); 
            //window.location.href = url;  

            var uploadFileUrl = process.env.__API_URL__ + "/downloadfile"

            uploadFileForGP(uploadFileUrl,blob, exportedFilenmae).then((uploadFileResult)=>{

                window.location.href = process.env.__API_OUTPUT_URL__ + "/"+uploadFileResult;

            });

        }
    }
}
//accept:
//fields: array, fields definition
//        sample: [ {key:"DRAWING",label:"Drawing Number"}, etc. ]
//keyHeaders: object, returned from extractFirstItemKeyAsHeaders function
//        sample: {"DRAWING":"DRAWING", etc.}
//return:
//{
// fieldName:Label,
// fieldName:Label,
// fieldName:Label,
// }

export function getCsvHeader(fields, items) {
  function extractFirstItemKeyAsHeaders(items) {
    var headers = {};
    var item = items[0];
    Object.keys(item).map(function (eachKey) {
      headers[eachKey] = eachKey
    });
    return headers;
  }
  

  function extractLabelAsHeaders(fields, keyHeaders) {

    // var headers = {};
    // this.fields.forEach(field => {
    //     headers[field.label] = '"'+field.label+'"'
    // });
    for (var headerField in keyHeaders) {
      fields.forEach(field => {
        if (headerField == field.key) {
          keyHeaders[headerField] = '"' + field.label + '"'
        }
      });
    }
    console.log("keyHeaders", keyHeaders);
    return keyHeaders;
  }

  return extractLabelAsHeaders(fields, extractFirstItemKeyAsHeaders(items));
}

export function getReplacementCsvHeader(fields, items) {
    function extractFirstItemKeyAsHeaders(items) {
      var headers = {};      
      var item = items[0];
      console.log(fields)
      fields.map(function (field) {
        headers[field.key] = field.label
      });
      console.log("The Header is",headers);
      return headers;
    }
    
  
    function extractLabelAsHeaders(fields, keyHeaders) {
  
      // var headers = {};
      // this.fields.forEach(field => {
      //     headers[field.label] = '"'+field.label+'"'
      // });
      for (var headerField in keyHeaders) {
        fields.forEach(field => {
          if (headerField == field.key) {
            keyHeaders[headerField] = '"' + field.label + '"'
          }
        });
      }
      console.log("keyHeaders", keyHeaders);
      return keyHeaders;
    }
  
    return extractLabelAsHeaders(fields, extractFirstItemKeyAsHeaders(items));
  }



export function extractHeaders(fieldsList){
    var headers = {};
    fieldsList.map(function(eachField){
        headers[eachField.key] = eachField.label
    });
    return headers;
}

export function extractFirstItemKeyAsHeaders(items){
    var headers = {};
    var item = items[0];
    Object.keys(item).map(function(eachKey){
        headers[eachKey] = eachKey
    });
    return headers;
}

export function formatItemsHandleEscape(items) {
    var formattedItems = [];
    var item = items[0];
    var keys = Object.keys(item);
    //loop all items 
    items.map(function (item) {
        var formattedItem = {};
        //loop all keys
        keys.map(function (key) {
            //handle escape characters
            var itemStr = sanitizeString(item[key]);
            //format item as string
            formattedItem[key] = '"' + itemStr + '"';
        })
        formattedItems.push(formattedItem);
    });
    return formattedItems;
}
 
//function to replace the escape characters
//https://stackoverflow.com/questions/46637955/write-a-string-containing-commas-and-double-quotes-to-csv
function sanitizeString(obj) {
    var itemDesc;
    if (typeof obj == "object"){
        obj = JSON.stringify(obj);
    }
    if (obj) {
        if (isNaN(obj)) {
            //to escape tap, new line etc
            itemDesc = obj.replace(/(\r\n|\n|\r|\s+|\t|&nbsp;)/gm, ' ');
            //to escape "
            itemDesc = itemDesc.replace(/"/g, '""');
            //to escape too much empty characters
            itemDesc = itemDesc.replace(/ +(?= )/g, '');
        }else {
            itemDesc = obj;
        }
    } else {
        itemDesc = '';
    }
    return itemDesc;
}



// WEBPACK FOOTER //
// ./src/tools/exportCSVFile.js